/**
 * 埋码管理左侧导航
 * 2019-6-17
 * Bai.Zhiming
 */
angular.module("hClassifyManagementLeftModule", []).
directive("hClassifyManagementLeft", ["$state", "hiddenCodeManagementService", "$timeout", "$q", "trsHttpService", function($state, hiddenCodeManagementService, $timeout, $q, trsHttpService) {
    return {
        replace: true,
        restrict: "E",
        scope: {},
        templateUrl: './manageConfig/sysManageMent/hiddenCodeManagement/classifyManagement/left/left_tpl.html',
        link: function(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [autoLocation description] 自动
             * @return {[type]} [description]
             */
            function autoLocation() {
                if ($state.current.name.indexOf('classifymanagement') >= 0) {
                    let path = $state.params.classifypath;
                    hiddenCodeManagementService.treeLocation(path, scope.data.treeModel, {}, scope.status.expandedNodes, selectedNode => {
                        scope.status.selectedNode = selectedNode;
                    });
                } else {
                    scope.recordRoute(scope.data.treeModel[0]);
                    scope.status.selectedNode = scope.data.treeModel[0];
                    scope.status.expandedNodes.push(scope.data.treeModel[0]);
                }
            }
            /**
             * [expandNode description] 展开父节点
             * @return {[type]} [description]
             */
            scope.expandNode = function(node) {
                if (node.CHILDREN) return;
                getNodeChildren(node);
            };

            scope.recordRoute = function(node, $event) {
                let path = node.id;
                if (!$event) {
                    $state.go("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", { classifyid: node.id, classifypath: path }, { reload: "manageconfig.sysmanage.hiddencodemanagement.classifymanagement" })
                } else {
                    console.log($event);
                    let $dom = $($event.target);
                    getNodePath(path + "", $dom, function(path) {
                        $state.go("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", { classifyid: node.id, classifypath: path }, { reload: "manageconfig.sysmanage.hiddencodemanagement.classifymanagement" })
                    });
                }
            }
            /**
             * [getNodePath description] 获取节点路径
             * @param  {[String]} path [description] 节点路径
             * @param  {[Object]} node [description] 节点
             * @param  {[Fn]} success [description] 回调
             * @return {[type]}      [description]
             */
            function getNodePath(path, $dom, success) {
                let nodeId, pathArray = path.split(",");
                try {
                    nodeId = $dom.parents("li").eq(0).data().$scope.$parent.node.id;
                    if (angular.isUndefined(nodeId)) {
                        success(pathArray.join(","));
                        return;
                    }
                    pathArray.unshift(nodeId + "");
                    getNodePath(pathArray.join(","), $dom.parents("li").eq(0), success);
                } catch (e) {
                    success(path);
                }

            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    options: {
                        nodeChildren: "CHILDREN",
                        allowDeselect: false,
                        dirSelectable: true,
                        injectClasses: {},
                        templateUrl: '../app/components/htmlTemplates/treeTemplate.html',
                        isLeaf: function(node) {
                            return node.CHILDREN && node.CHILDREN.length == 0;
                        }
                    },
                    expandedNodes: [],
                    selectedNode: {}
                };
                scope.data = {
                    treeModel: [{
                        id: 0,
                        parentclassify: '分类管理',
                        parentid: null
                    }]
                };
                scope.$on("leftReload", () => {
                    let treeModel = angular.copy(scope.data.treeModel);
                    treeModel[0].CHILDREN = [];
                    getNodeChildren(treeModel[0]).then(() => {
                        let path = $state.params.classifypath;
                        let expandedNodes = [];
                        //scope.status.expandedNodes.splice(0, scope.status.expandedNodes.length - 1);
                        hiddenCodeManagementService.treeLocation(path, treeModel, scope.status.selectedNode, expandedNodes, selectedNode => {
                            scope.status.selectedNode = selectedNode;
                            scope.data.treeModel = treeModel;
                            scope.status.expandedNodes = expandedNodes;
                        });
                    })
                })
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getNodeChildren(scope.data.treeModel[0]).then(() => {
                    autoLocation();
                    //scope.status.expandedNodes.push(scope.data.treeModel[0]);
                });
            }
            /**
             * [getNodeChildren description] 获取子节点
             * @param  {[Object]} node [parentNode] 父节点
             * @return {[type]} [description]
             */
            function getNodeChildren(parentNode) {
                let deffer = $q.defer();
                let params = {
                    serviceid: 'mlf_buridecode',
                    methodname: 'get',
                    parentid: parentNode.id
                };
                hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
                    parentNode.CHILDREN = resp.data
                    deffer.resolve();
                });
                return deffer.promise;
            }
        }
    };
}]);